import { Link } from '@tanstack/react-router'
import { RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { useClientLinearIssues, useRefreshClientLinearIssues } from '@/queries/clientDashboards'

export function LinearSyncCard({ companyId, clientName }: { companyId: string; clientName: string }) {
  const linear = useClientLinearIssues(companyId).data?.data
  const refresh = useRefreshClientLinearIssues(companyId)
  if (!linear) return null

  return (
    <Card>
      <CardHeader>
        <CardTitle>Linear</CardTitle>
        <CardDescription>
          The Linear Tickets tab shows the issues carrying this client&apos;s Linear customer. It stays current on its own and is re-checked
          against Linear once a day.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {linear.linked ? (
          <>
            <p className="text-sm text-etn-text-cell">
              Linked to <span className="font-medium text-etn-text">{linear.customerName ?? 'a Linear customer'}</span>
            </p>
            <Button variant="outline" onClick={() => refresh.mutate()} disabled={refresh.isPending}>
              <RefreshCw className={refresh.isPending ? 'animate-spin' : undefined} aria-hidden />
              Refresh from Linear
            </Button>
            <p className="text-xs text-etn-text-soft">Re-reads this client&apos;s issues from Linear now. Nothing in Linear is changed.</p>
          </>
        ) : (
          <p className="text-sm text-etn-text-soft">
            {clientName} isn&apos;t linked to a Linear customer yet. Link it under Linear customers on the{' '}
            <Link to={'/admin/settings' as never} className="font-medium text-etn-accent-text-active hover:underline">
              Settings page
            </Link>
            .
          </p>
        )}
      </CardContent>
    </Card>
  )
}
